import RequestParameterRows from './RequestParameterRows';

export default RequestParameterRows;
